/* unplugin-vue-components disabled */import { render } from "./moduleCard.vue?vue&type=template&id=26659fac&scoped=true"
import script from "./moduleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./moduleCard.vue?vue&type=script&setup=true&lang=js"

import "./moduleCard.vue?vue&type=style&index=0&id=26659fac&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./moduleCard.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_56c7d0d1d885c2cba1c2415451171383/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26659fac"],['__file',"src/components/moduleCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26659fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26659fac', __exports__)) {
    api.reload('26659fac', __exports__)
  }
  
  module.hot.accept("./moduleCard.vue?vue&type=template&id=26659fac&scoped=true", () => {
    api.rerender('26659fac', render)
  })

}


export default __exports__